import stepsApi from './steps';
import leadApi from './lead';

export default {
  leadApi,
  stepsApi
};
